export const BASE_URL = 'https://api.escuelajs.co/api/v1';